import React from "react";
import "../css/index.css";
import { Link } from 'react-router-dom';
import Logo from '../assets/logo.png';
import Back from '../assets/back.jpg';

const Index = () => {
  
  return (
    <div id="body"> 
    <div id="int-container">
        <div>
            <img src={Logo} alt="Logo" className="logo"/>
        </div>
        <div>
            <p className="infra">infraconsoft.net.in</p>
        </div>
    </div>

    <div className="content">
        <div className="con-1">
            <h1 className="heading">Transforming Construction with Innovation</h1>
            <p className="desc">
                Embrace a new era of construction with our groundbreaking software solutions. From project management to real-time analytics, we provide tools that redefine what’s possible, turning complex processes into streamlined, intuitive workflows for every team.
            </p>
			
            <button className="styled-button">
                <Link to='/login'> Click here to login</Link>
            </button>
		
        </div>

        <div className="con-2">
            <img src={Back} alt="Background Image" />
        </div>
    </div>

    </div>
  );
};

export default Index;
 